import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import CostTypeRestModel from "../../../../models/rest/register/costTypeRestModel";
import SettlementCostDocumentItemRestModel, { createEmptyCostDocumentItem } from "../../../../models/rest/settlement/cost-document/settlementCostDocumentItemRestModel";
import SettlementCostDocumentRestModel from "../../../../models/rest/settlement/cost-document/settlementCostDocumentRestModel";

@Component({
    props: {
        currencyRate: {
            default: undefined
        },
        parentComponentName: {
            default: ""
        },
    }
})

export default class CostDocumentItemDialog extends Vue {
    currencyRate!: number | undefined;
    parentComponentName!: string;
    item: SettlementCostDocumentItemRestModel = {} as SettlementCostDocumentItemRestModel;

    rules = {
        costType: [
            () => {
                const error = this.validationError.CostType != undefined ? this.validationError.CostType[0] : "";
                return error == "" || error;
            }],
        descriptionDetailed: [
            () => {
                const error = this.validationError.DescriptionDetailed != undefined ? this.validationError.DescriptionDetailed[0] : "";
                return error == "" || error;
            }],
        itemQuantity: [
            () => {
                const error = this.validationError.Quantity != undefined ? this.validationError.Quantity[0] : "";
                return error == "" || error;
            }],
        itemUnit: [
            () => {
                const error = this.validationError.Unit != undefined ? this.validationError.Unit[0] : "";
                return error == "" || error;
            }],
        itemTaxRate: [
            () => {
                const error = this.validationError.TaxRate != undefined ? this.validationError.TaxRate[0] : "";
                return error == "" || error;
            }],
        itemPrice: [
            () => {
                const error = this.validationError.Price != undefined ? this.validationError.Price[0] : "";
                return error == "" || error;
            }],
        itemPricePln: [
            () => {
                const error = this.validationError.PricePln != undefined ? this.validationError.PricePln[0] : "";
                return error == "" || error;
            }],
        itemNetto: [
            () => {
                const error = this.validationError.Netto != undefined ? this.validationError.Netto[0] : "";
                return error == "" || error;
            }],
        itemNettoPln: [
            () => {
                const error = this.validationError.NettoPln != undefined ? this.validationError.NettoPln[0] : "";
                return error == "" || error;
            }],
        itemBrutto: [
            () => {
                const error = this.validationError.Brutto != undefined ? this.validationError.Brutto[0] : "";
                return error == "" || error;
            }],
        itemBruttoPln: [
            () => {
                const error = this.validationError.BruttoPln != undefined ? this.validationError.BruttoPln[0] : "";
                return error == "" || error;
            }],
        itemTax: [
            () => {
                const error = this.validationError.Tax != undefined ? this.validationError.Tax[0] : "";
                return error == "" || error;
            }],
        itemTaxPln: [
            () => {
                const error = this.validationError.TaxPln != undefined ? this.validationError.TaxPln[0] : "";
                return error == "" || error;
            }],
    }

    get validationError(): any {
        return this.$store.direct.state.settlementCostDocument.costDocumentItemValidationError;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.settlementCostDocument.showCostDocumentItemDialog;
    }

    get title(): string {
        return this.$store.direct.state.settlementCostDocument.costDocumentItemDialogTitle;
    }

    get isFromCorrection(): boolean {
        return this.$store.direct.state.settlementCostDocument.costDocumentItemDialogIsFromCorrection;
    }

    get originalItem(): SettlementCostDocumentItemRestModel {
        return this.$store.direct.state.settlementCostDocument.costDocumentItem;
    }

    set originalItem(val: SettlementCostDocumentItemRestModel) {
        this.$store.direct.commit.settlementCostDocument.setCostDocumentItem(val);
    }

    get itemList() {
        if (this.isFromCorrection) {
            return this.$store.direct.state.settlementCostDocument.costDocumentItemCorrectionList;
        }
        return this.$store.direct.state.settlementCostDocument.costDocumentItemList;
    }

    set itemList(val: SettlementCostDocumentItemRestModel[]) {
        if (this.isFromCorrection) {
            this.$store.direct.commit.settlementCostDocument.setCostDocumentItemCorrectionList(val);
        }
        this.$store.direct.commit.settlementCostDocument.setCostDocumentItemList(val);
    }

    get costTypeList(): CostTypeRestModel[] {
        return this.$store.direct.state.settlementCommon.settlementAssets.costTypes;
    }

    get countryTaxRates(): number[] {
        return this.$store.direct.state.register.countryTaxRateArray;
    }

    get costDocument(): SettlementCostDocumentRestModel {
        return this.$store.direct.state.settlementCostDocument.costDocument;
    }

    allowNumbersOnly(evt: any) {
        return this.$store.direct.dispatch.settlementCommon.allowNumbersOnly({ evt });
    }

    cloneItemForEdit(item: SettlementCostDocumentItemRestModel): SettlementCostDocumentItemRestModel {
        return JSON.parse(JSON.stringify(item)) as SettlementCostDocumentItemRestModel;
    }

    @Watch("showDialog")
    async showDialogHandler(val: any) {
        if (this.showDialog == true) {
            this.item = this.originalItem != undefined
                ? this.cloneItemForEdit(this.originalItem)
                : createEmptyCostDocumentItem();

            if (this.item.costType == undefined || this.item.costType.id == undefined) {
                const carrierFreightCostType = this.costTypeList.find((x: CostTypeRestModel) => {
                    return x.id == 9; // Fracht przewoznika
                })
                this.item.costType = { ...carrierFreightCostType } as CostTypeRestModel;
            }

            if (this.item.price != undefined && !this.item.isManualEdit) {
                await this.assignItemPricePln(this.item);
            }
        }
    }

    @Watch("currencyRate")
    async currencyRateHandler() {
        if (this.showDialog == true && this.item.price != undefined && !this.item.isManualEdit) {
            await this.assignItemPricePln(this.item);
        }
    }

    async created() {
        await this.$store.direct.dispatch.settlementCommon.loadSettlementAssets();
    }

    async assignItemPricePln(item: SettlementCostDocumentItemRestModel) {
        if (this.currencyRate != undefined && this.currencyRate != 0) {
            item.pricePln = this.roundValueToTwoPlaces(item.price * this.currencyRate);
        }
        else {
            item.pricePln = item.price;
        }
        await this.calculateNettoBruttoAndTaxValueInPln(item);
    }

    roundValueToTwoPlaces(value: number) {
        return Math.round(value * 100) / 100;
    }

    changeCommaToDot(val: any): number {
        return parseFloat(val.toString().replace(",", "."));
    }

    changeCommaToDotNetto() {
        if (this.item.netto != undefined && this.item.isManualEdit) {
            this.item.netto = this.changeCommaToDot(this.item.netto);
        }
    }

    changeCommaToDotTax() {
        if (this.item.tax != undefined && this.item.isManualEdit) {
            this.item.tax = this.changeCommaToDot(this.item.tax);
        }
    }

    changeCommaToDotBrutto() {
        if (this.item.brutto != undefined && this.item.isManualEdit) {
            this.item.brutto = this.changeCommaToDot(this.item.brutto);
        }
    }

    changeInPricePln() {
        if (this.item.pricePln != undefined && this.item.isManualEdit) {
            this.item.pricePln = this.changeCommaToDot(this.item.pricePln);
        }
        this.calculateNettoBruttoAndTaxValueInPln(this.item);
    }

    async calculateNettoBruttoAndTaxValue() {
        if (this.item.price != undefined) {
            this.item.price = this.changeCommaToDot(this.item.price);
        }

        if (!this.item.isManualEdit) {
            await this.$store.direct.dispatch.settlementCommon.calculateNettoBruttoAndTaxValue({ item: this.item, parentComponentName: this.parentComponentName });
            if (this.item.price != undefined) {
                await this.assignItemPricePln(this.item);
            }
            else {
                await this.calculateNettoBruttoAndTaxValueInPln(this.item);
            }
        }
        this.$forceUpdate();        //nie zawsze odświeża się wartość w polu tekstowym po wklejeniu, więc wymuszam odświeżenie komponentu
    }

    changeCommaToDotNettoPln() {
        if (this.item.nettoPln != undefined && this.item.isManualEdit) {
            this.item.nettoPln = this.changeCommaToDot(this.item.nettoPln);
        }
    }

    changeCommaToDotTaxPln() {
        if (this.item.taxPln != undefined && this.item.isManualEdit) {
            this.item.taxPln = this.changeCommaToDot(this.item.taxPln);
        }
    }

    changeCommaToDotBruttoPln() {
        if (this.item.bruttoPln != undefined && this.item.isManualEdit) {
            this.item.bruttoPln = this.changeCommaToDot(this.item.bruttoPln);
        }
    }

    async calculateNettoBruttoAndTaxValueInPln(item: SettlementCostDocumentItemRestModel) {
        await this.$store.direct.dispatch.settlementCommon.calculateNettoBruttoAndTaxValueInPln({ item: item, parentComponentName: this.parentComponentName });
    }

    async onManualEditChange() {
        if (!this.item.isManualEdit) {
            await this.calculateNettoBruttoAndTaxValue();
        }
    }

    cancelClick() {
        this.$store.direct.dispatch.settlementCostDocument.isNotConfirmedCostDocumentItemDialog();
        this.item = createEmptyCostDocumentItem();
    }

    async saveClick() {
        this.item.isDocumentCorrection = this.costDocument.isDocumentCorrection;
        this.item.taxRate = (this.item.taxRate == undefined || this.item.taxRate.toString().length == 0) ? 0 : this.item.taxRate as any;
        this.$forceUpdate();

        await this.$store.direct.dispatch.settlementCostDocument.validateCostDocumentItem({ item: this.item });

        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (Object.keys(this.validationError).length === 0) {
            if (this.$refs.form != undefined) {
                const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
                await this.$store.direct.dispatch.settlementCostDocument.isConfirmedCostDocumentItemDialog();

                if (this.originalItem != undefined) {
                    this.originalItem.id = this.item.id;
                    this.originalItem.costType = { ...this.item.costType } as CostTypeRestModel;
                    this.originalItem.descriptionDetailed = this.item.descriptionDetailed;
                    this.originalItem.isDocumentCorrection = this.item.isDocumentCorrection;
                    this.originalItem.price = this.item.price;
                    this.originalItem.pricePln = this.item.pricePln;
                    this.originalItem.netto = this.item.netto;
                    this.originalItem.nettoPln = this.item.nettoPln;
                    this.originalItem.brutto = this.item.brutto;
                    this.originalItem.bruttoPln = this.item.bruttoPln;
                    this.originalItem.quantity = this.item.quantity;
                    this.originalItem.taxRate = this.item.taxRate;
                    this.originalItem.tax = this.item.tax;
                    this.originalItem.taxPln = this.item.taxPln;
                    this.originalItem.taxTypeId = this.item.taxTypeId;
                    this.originalItem.serviceTypeId = this.item.serviceTypeId;
                    this.originalItem.unit = this.item.unit;
                    this.originalItem.isManualEdit = this.item.isManualEdit;
                }
                else {
                    this.itemList.push(this.item)
                }

                this.item = createEmptyCostDocumentItem();
            }
        }
    }
}
